import React, { Component } from 'react'
import styled from 'styled-components'
import { FlexWrapper, PageWrapper, Button, XLText, Card, XXLText, ProgressBar } from '../components'
import bgImg from '../static/images/new-background.png'

const ImageWrapper = styled.div`
  background-image: url(${bgImg});
  margin: 10px;
  max-width: 100%;
  height: 460px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  /* box-shadow: 0 3px 14px rgba(0, 0, 0, 0.16); */
  & > img {
    max-width: 100%;
    height: 150px;
    object-fit: contain;
    padding: 0 30px;
  }
`

class OnBoarding extends Component {
  state = {
    onBoarding: false
  }
  render() {
    const { onBoarding } = this.state
    return (
      <PageWrapper viewPadding="11% 8%">
        <FlexWrapper alignItems="center" height="100%">
          {onBoarding ? (
            <React.Fragment>
              <XLText>Our GreenScores</XLText>
              <Card margin="30px 0 0">
                <XXLText>
                  We evaluate companies and their products across 7 dimensions of health and sustainability.
                </XXLText>
                <FlexWrapper viewPadding={'20px 0 0 0'}>
                  <XXLText>
                    Each dimension is scored 0 to 100, and together the 7 dimensions comprise a product's GreenScore.
                  </XXLText>
                </FlexWrapper>
                <FlexWrapper direction="row" viewMargin="30px 0 0" justifyContent="space-between">
                  <ProgressBar percentage={20} initialAnimation={true} strokeWidth={16} />
                  <ProgressBar percentage={60} initialAnimation={true} strokeWidth={16} />
                  <ProgressBar percentage={90} initialAnimation={true} strokeWidth={16} />
                </FlexWrapper>
              </Card>
              <Button
                size="small"
                namespace="Greenscore Onboarding"
                label="Got it"
                onClick={() => this.props.history.push('/auth/social-login')}
                margin="13% auto 0"
              />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <ImageWrapper>
                <img src={require('../static/images/new_logo.png')} alt="Greenchoice" />
              </ImageWrapper>
              <Button
                label="Lets get started"
                namespace="First Screen"
                isLoading={false}
                margin="auto 0 0"
                onClick={() => this.setState({ onBoarding: true })}
              />
            </React.Fragment>
          )}
        </FlexWrapper>
      </PageWrapper>
    )
  }
}

export default OnBoarding



// WEBPACK FOOTER //
// ./src/pages/OnBoarding.js